import React from 'react';
import { SearchForm } from '../../../components/organism/SearchForm/SearchForm';
import { MyNetworkCard } from '../../../components/organism/MyNetworkCard/MyNetworkCard';
import useSearchMyNetwork from '../../../features/searchMyNetwork/application/useSearchMyNetwork';
import { Notification } from "../../../components/molecules/Notification/Notification";
import { GeneralLayout } from '../../../components/layout/GeneralLayout/GeneralLayout';

export const SearchMyNetworkPage: React.FC = () => {
  const { setFormData, handleSubmit, clearRegistrationError, data } =
    useSearchMyNetwork();
  // Un manejador de cambios genérico para simplificar los inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...data.formData,
      [name]: value,
    });
  };

  return (
    <GeneralLayout>
      {!data.responseSearchMyNetwork.success && (
        <div className="card">
          <h1 className="text-2xl font-bold mb-7 mt-7 text-center">Consultar mi red</h1>
          <p className="text-gray-500 mb-6 text-center">
            Ingresa tu número de celular para ver consultar tu red.
          </p>
          <SearchForm
            textButton="Buscar"
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            data={data}
          />
        </div>
      )}
      {data.responseSearchMyNetwork.success &&
        data.responseSearchMyNetwork.data && (
          <MyNetworkCard
            direct={data.responseSearchMyNetwork.data.direct}
            indirect={data.responseSearchMyNetwork.data.indirect}
            userName={data.responseSearchMyNetwork.data.userName}
          />
        )}
      {data.error && (
        <Notification
          message={
            data.responseSearchMyNetwork.message ||
            "Ha ocurrido un error. Por favor, intenta de nuevo."
          }
          type="error"
          onClose={clearRegistrationError}
        />
      )}
    </GeneralLayout>
  );
};
